import { lazy, Suspense } from 'react';

import { FullScreenBrandLoader } from '@/components/shared/full-screen-brand-loader';

import { useAuthLanguageSync } from './use-auth-language-sync';

import type { ReactNode } from 'react';

interface AuthLayoutProps {
  readonly children: ReactNode;
}

const AuthLayoutContent = lazy(async () => await import('./auth-layout-content'));

const AuthLayout = ({ children }: AuthLayoutProps) => {
  useAuthLanguageSync();
  return (
    <Suspense fallback={<FullScreenBrandLoader />}>
      <AuthLayoutContent>{children}</AuthLayoutContent>
    </Suspense>
  );
};

export default AuthLayout;
